<ng-container *transloco="let t; prefix: 'footer'">
  <div class="footer-container">
    <div class="accredible-content">
      <div class="top-content">
        <div class="logo-social-container">
          <img
            src="/assets/images/directory-of-directories/accredible-logo.png"
            [alt]="t('aria_logo')" />

          <p>{{ t('description') }}</p>

          <div class="social-media-links">
            <nav [attr.aria-label]="t('aria_social_links')" class="social-nav" role="navigation">
              <ul>
                @for (social of socialLinks; track social.url) {
                  <li>
                    <a [href]="social.url" target="_blank">
                      <accredible-icon [icon]="social.icon" />
                    </a>
                  </li>
                }
              </ul>
            </nav>
          </div>
        </div>

        <div class="footer-links">
          <nav [attr.aria-label]="t('aria_footer_links')" class="footer-nav" role="navigation">
            @for (column of footerColumns; track column.title) {
              <div class="links-group">
                <h2>{{ t(column.title) }}</h2>
                <ul>
                  @for (link of column.links; track link.url) {
                    <li>
                      <a [href]="link.url" target="_blank">{{ t(link.label) }}</a>
                    </li>
                  }
                </ul>
              </div>
            }
          </nav>
        </div>
      </div>

      <div class="bottom-content">
        <div class="copyright" [innerHTML]="t('copyright', { year: currentYear })"></div>

        <div class="legal-links">
          <ul role="navigation">
            @for (link of legalLinks; track link.url) {
              <li>
                <a [href]="link.url" target="_blank">{{ t(link.label) }}</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-container>
